import { useState, useEffect, useMemo } from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import TabPanel from './TabPanel';
import { setReRender, setTabOnFocus } from '../../store/global/actions';
import { marginBottomForBreadCrumb } from '../../config/styles';
import { useDispatch, useSelector } from 'react-redux';
import BreadCrumb from '../atoms/breadcrumb/';
import { getTabOnFocus } from '../../store/global/selectors';
import Divider from '@material-ui/core/Divider';
import { Grid } from '@material-ui/core';
import { handleSnackBar } from '../../store/global/actions';
import { toggleRightDrawer } from '../../store/global/actions'
import { getElementOnFocus } from '../../store/global/selectors'
import { findSelectedSchema } from '../../services/builder/util';
import { getViews } from '../../store/views/selectors';
import SectionForm from '../molecules/dashboardBuilder/SectionForm';
import MappingSelector from '../molecules/dashboardBuilder/MappingSelector';
import { useBottomDrawer } from '../../hooks/useBottomDrawer';

export default function ViewSection({ element }) {
    const dispatch = useDispatch();
    const tabOnFocus = useSelector(getTabOnFocus);
    const elementOnFocus = useSelector(getElementOnFocus)
    const selectedView = useSelector(getViews);
    const selectedSection = findSelectedSchema({ schemas: selectedView?.view_schema, id: element?.id });
    const {setTabConfig, activeTab, setActiveTab} = useBottomDrawer()

    const hideDatasourceTab = selectedSection === undefined || selectedSection?.viewCopy === true 

    useEffect(() => {
        setActiveTab(tabOnFocus);
    }, [tabOnFocus])


    const onCompletion = (type, action) => {
        if (action != undefined) {

            switch (action) {
                case 'add':
                    dispatch(handleSnackBar({ open: true, message: `${type} created`, severity: "success" }));
                    break;

                case 'edit':
                    dispatch(handleSnackBar({ open: true, message: `${type} updated`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    break;

                case 'delete':
                    dispatch(handleSnackBar({ open: true, message: `${type} deleted`, severity: "success" }));
                    dispatch(toggleRightDrawer());
                    break;
                default:
                    break;

            }
            dispatch(setReRender());
        }
    }

    const onClose = () => {
        dispatch(toggleRightDrawer());
    }

    useEffect(() => {
        const tabs = [
            {
                label: "Section"
            }
        ]

        if(!hideDatasourceTab){
            tabs.push({
                label: "Data Source",
                isDisabled: elementOnFocus?.action === "create"
            })
        }

        setTabConfig(tabs)
    },[elementOnFocus, hideDatasourceTab])

    return (
        <>
                {/* <AppBar position="static">
                    <Tabs value={openTab} onChange={(e, v) => { dispatch(setTabOnFocus(v)); setOpenTab(v) }} aria-label="simple tabs example">
                        <Tab label="Section" />
                        { !hideDatasourceTab &&  <Tab label="Data Source" disabled={elementOnFocus?.action === "create" ? true : false}/> }
                    </Tabs>
                </AppBar> */}


            <TabPanel value={activeTab} index={0} >
                <SectionForm action={selectedSection ? "edit" : "create"} onClose={onClose} selectedSection={selectedSection}/>
            </TabPanel>

            {!hideDatasourceTab && 
            <TabPanel value={activeTab} index={1} >
                <MappingSelector id={elementOnFocus.id} type={elementOnFocus.type} action={elementOnFocus.action} onClose={onClose} rootId={elementOnFocus.rootId} onCompletion={onCompletion} />
            </TabPanel> 
            }

        </>
    )
}